import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {nameValidation, phoneValidation, emailValidation, passwordValidation, dateValidation, dateNoYearValidation, zipValidation, locationValidation} from '../../../../utils/itemValidation';
import {displayPhone, displayPhoneInput, displayDate, displayDateInput, displayDateNoYear, displayDateNoYearInput, stringToDigits, formatDropdownData, formatDbDate, formatDateForDb} from '../../../../utils/formatting';

import {ringSizes, ringFingers} from '../../../../constants/ringsizes';
import {states} from '../../../../constants/states';
import {locations} from '../../../../constants/locations';

import * as commonActionCreators from '../../../../actions/common';
import * as userActionCreators from '../../../../actions/user';
let allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);

import RhinoLoading from '../../common/RhinoLoading';

class AccountInfo extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let ringLabel = [
      {
        display: 'Size',
        value: '',
      }
    ];

    let fingerLabel = [
      {
        display: 'Finger',
        value: '',
      }
    ];

    // let phoneVal = '';
    // if(this.props.user.userCore && this.props.user.userCore.addresses && this.props.user.userCore.addresses.length > 0) {
    //   phoneVal = this.props.user.userCore.addresses[0].telephone;
    // }

		this.state = {

      stateDropdownData: formatDropdownData(states, 'name', 'abbreviation', 'State'),
      locationDropdownData: formatDropdownData(locations, 'name', 'number', 'Select Location'),

      nameOpen: false,
      firstName: this.props.user.userCore && this.props.user.userCore.firstname ? this.props.user.userCore.firstname : '',
      firstNameError: null,
      lastName: this.props.user.userCore && this.props.user.userCore.lastname ? this.props.user.userCore.lastname : '',
      lastNameError: null,

      phone: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.phone ? this.props.user.userProfile.customer.phone : '',
      phoneError: null,
      phoneOpen: false,

      email: this.props.user.userCore && this.props.user.userCore.email ? this.props.user.userCore.email : '',
      emailError: null,
      emailOpen: false,

      birthday: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.date_of_birth ? formatDbDate(this.props.user.userProfile.customer.date_of_birth) : '',
      birthdayError: null,
      birthdayOpen: false,

      soNameOpen: false,
      soFirstName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].first_name ? this.props.user.userProfile.spouses[0].first_name : '',
      soFirstNameError: null,
      soLastName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].last_name ? this.props.user.userProfile.spouses[0].last_name : '',
      soLastNameError: null,

      soEmail: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].email ? this.props.user.userProfile.spouses[0].email : '',
      soEmailError: null,
      soEmailOpen: false,

      soBirthday: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].birthdate ? formatDbDate(this.props.user.userProfile.spouses[0].birthdate) : '',
      soBirthdayError: null,
      soBirthdayOpen: false,

      anniversary: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.anniversary_date ? formatDbDate(this.props.user.userProfile.customer.anniversary_date) : '',
      anniversaryError: null,
      anniversaryOpen: false,

      ringSize: this.props.user.userProfile && this.props.user.userProfile.ringSizes ? this.props.user.userProfile.ringSizes : [],
      ringSizeOpen: false,
      ringSizeData: ringLabel.concat(ringSizes),
      ringFingerData: fingerLabel.concat(ringFingers),

      homeAddressId: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].id ? this.props.user.userProfile.addresses[0].id : null,
      homeAddressStreet1: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].street1 ? this.props.user.userProfile.addresses[0].street1 : '',
      homeAddressStreet2: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].street2 ? this.props.user.userProfile.addresses[0].street2 : '',
      homeAddressCity: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].city ? this.props.user.userProfile.addresses[0].city : '',
      homeAddressState: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].state ? this.props.user.userProfile.addresses[0].state : '',
      homeAddressZip: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[0] && this.props.user.userProfile.addresses[0].zipcode ? this.props.user.userProfile.addresses[0].zipcode : '',
      homeAddressStreet1Error: null,
      homeAddressStreet2Error: null,
      homeAddressCityError: null,
      homeAddressStateError: null,
      homeAddressZipError: null,
      homeAddressOpen: false,

      shippingAddressId: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].id ? this.props.user.userProfile.addresses[1].id : null,
      shippingAddressStreet1: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].street1 ? this.props.user.userProfile.addresses[1].street1 : '',
      shippingAddressStreet2: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].street2 ? this.props.user.userProfile.addresses[1].street2 : '',
      shippingAddressCity: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].city ? this.props.user.userProfile.addresses[1].city : '',
      shippingAddressState: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].state ? this.props.user.userProfile.addresses[1].state : '',
      shippingAddressZip: this.props.user.userProfile && this.props.user.userProfile.addresses && this.props.user.userProfile.addresses[1] && this.props.user.userProfile.addresses[1].zipcode ? this.props.user.userProfile.addresses[1].zipcode : '',
      shippingAddressStreet1Error: null,
      shippingAddressStreet2Error: null,
      shippingAddressCityError: null,
      shippingAddressStateError: null,
      shippingAddressZipError: null,
      shippingAddressOpen: false,

      localStore: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.store_number ? this.props.user.userProfile.customer.store_number : '',
      localStoreOpen: false,

      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      passwordError: false,
      passwordOpen: false,
      passwordReset: false,

      optIn: true,
    };
	}

	componentDidMount() {
    this.props.setFirstNameMethod(this.state.firstName);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.user.userCore === null && this.props.user.userCore != null) {
      
      this.setState({
        firstName: this.props.user.userCore.firstname,
        lastName: this.props.user.userCore.lastname,
        email: this.props.user.userCore.email,
      });
    }

    if(prevProps.user.userProfile === null && this.props.user.userProfile != null) {

      let phoneVal = '';

      let homeAddressId = null;
      let homeAddressStreet1 = '';
      let homeAddressStreet2 = '';
      let homeAddressCity = '';
      let homeAddressState = '';
      let homeAddressZip = '';

      let shippingAddressId = null;
      let shippingAddressStreet1 = '';
      let shippingAddressStreet2 = '';
      let shippingAddressCity = '';
      let shippingAddressState = '';
      let shippingAddressZip = '';

      console.log(this.props.user.userProfile.addresses);

      if(this.props.user.userProfile.addresses && this.props.user.userProfile.addresses.length > 0) {
        console.log('have addresses!');

        for(let i = 0; i < this.props.user.userProfile.addresses.length; i++) {

          // Right now, only support / look at first two addresses
          if(i >= 2) { break; }

          // TODO: add address type
          // Home address
          if(i === 0) {
            homeAddressId = this.props.user.userProfile.addresses[i].id ? this.props.user.userProfile.addresses[i].id : null;
            homeAddressStreet1 = this.props.user.userProfile.addresses[i].street1 ? this.props.user.userProfile.addresses[i].street1 : '';
            homeAddressStreet2 = this.props.user.userProfile.addresses[i].street2 ? this.props.user.userProfile.addresses[i].street2 : '';
            homeAddressCity = this.props.user.userProfile.addresses[i].city ? this.props.user.userProfile.addresses[i].city : '';
            homeAddressState = this.props.user.userProfile.addresses[i].state ? this.props.user.userProfile.addresses[i].state : '';
            homeAddressZip = this.props.user.userProfile.addresses[i].zipcode ? this.props.user.userProfile.addresses[i].zipcode : '';
          }

          // Shipping address
          if(i === 1) {
            shippingAddressId = this.props.user.userProfile.addresses[i].id ? this.props.user.userProfile.addresses[i].id : null;
            shippingAddressStreet1 = this.props.user.userProfile.addresses[i].street1 ? this.props.user.userProfile.addresses[i].street1 : '';
            shippingAddressStreet2 = this.props.user.userProfile.addresses[i].street2 ? this.props.user.userProfile.addresses[i].street2 : '';
            shippingAddressCity = this.props.user.userProfile.addresses[i].city ? this.props.user.userProfile.addresses[i].city : '';
            shippingAddressState = this.props.user.userProfile.addresses[i].state ? this.props.user.userProfile.addresses[i].state : '';
            shippingAddressZip = this.props.user.userProfile.addresses[i].zipcode ? this.props.user.userProfile.addresses[i].zipcode : '';
          }
        }
      } else {
        console.log('no addresses');
      }

      // if(this.props.user.userCore.addresses && this.props.user.userCore.addresses.length > 0) {
        
      //   cityVal = this.props.user.userCore.addresses[0].city;
      //   zipVal = this.props.user.userCore.addresses[0].postcode;

      //   if(this.props.user.userCore.addresses.street && this.props.user.userCore.addresses.street.length > 0) {
      //     street1Val = this.props.user.userCore.addresses[0].street[0];
      //   }

      //   if(this.props.user.userCore.addresses.street && this.props.user.userCore.addresses.street.length > 1) {
      //     street2Val = this.props.user.userCore.addresses[0].street[1];
      //   }
      // }
      
      this.setState({
        phone: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.phone ? this.props.user.userProfile.customer.phone : '',
        birthday: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.date_of_birth ? formatDbDate(this.props.user.userProfile.customer.date_of_birth) : '',
        soFirstName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].first_name ? this.props.user.userProfile.spouses[0].first_name : '',
        soLastName: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].last_name ? this.props.user.userProfile.spouses[0].last_name : '',
        soEmail: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].email ? this.props.user.userProfile.spouses[0].email : '',
        soBirthday: this.props.user.userProfile && this.props.user.userProfile.spouses && this.props.user.userProfile.spouses[0] && this.props.user.userProfile.spouses[0].birthdate ? formatDbDate(this.props.user.userProfile.spouses[0].birthdate) : '',
        anniversary: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.anniversary_date ? formatDbDate(this.props.user.userProfile.customer.anniversary_date) : '',
        ringSize: this.props.user.userProfile && this.props.user.userProfile.ringSizes ? this.props.user.userProfile.ringSizes : [],
        localStore: this.props.user.userProfile && this.props.user.userProfile.customer && this.props.user.userProfile.customer.store_number ? this.props.user.userProfile.customer.store_number : '',

        homeAddressId: homeAddressId,
        homeAddressStreet1: homeAddressStreet1,
        homeAddressStreet2: homeAddressStreet2,
        homeAddressCity: homeAddressCity,
        homeAddressState: homeAddressState,
        homeAddressZip: homeAddressZip,

        shippingAddressId: shippingAddressId,
        shippingAddressStreet1: shippingAddressStreet1,
        shippingAddressStreet2: shippingAddressStreet2,
        shippingAddressCity: shippingAddressCity,
        shippingAddressState: shippingAddressState,
        shippingAddressZip: shippingAddressZip,
      });
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  syncUserProfile(updates) {
    let baseData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      phone: this.state.phone,
    };
    let updateData = Object.assign({}, baseData, updates);
    this.props.userSetProfile(updateData)
    .then((resp) => {
      console.log(resp);

      this.props.userGetUser()
      .then((resp) => {        
        this.props.userSaveCore(resp);
      });

      this.props.userGetProfile()
      .then((resp) => {        
        this.props.userSaveProfile(resp);
      });
    });
  }

  // =================== //
  // First and last name //
  // =================== //

  openName() {
    this.setState({ nameOpen: true });
  }

  changeFirstName(evt) {
    this.setState({ firstName: evt.target.value });
  }

  validateFirstName() {
    setTimeout(() => {
      this.setState({ firstNameError: nameValidation(this.state.firstName) });
    }, 100);
  }

  changeLastName(evt) {
    this.setState({ lastName: evt.target.value });
  }

  validateLastName() {
    setTimeout(() => {
      this.setState({ lastNameError: nameValidation(this.state.lastName) });
    }, 100);
  }

  saveName() {
    
    let firstNameError = nameValidation(this.state.firstName);
    let lastNameError = nameValidation(this.state.lastName);
    
    if(firstNameError || lastNameError) {
      this.setState({ 
        firstNameError: firstNameError, 
        lastNameError: lastNameError,
      });
    } else {
      this.setState({ nameOpen: false }, () => {
        this.syncUserProfile({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
        });
      });
      this.props.setFirstNameMethod(this.state.firstName);
    }
  }

  // ====================== //
  // SO First and last name //
  // ====================== //

  openSoName() {
    this.setState({ soNameOpen: true });
  }

  changeSoFirstName(evt) {
    this.setState({ soFirstName: evt.target.value });
  }

  validateSoFirstName() {
    setTimeout(() => {
      this.setState({ soFirstNameError: nameValidation(this.state.soFirstName) });
    }, 100);
  }

  changeSoLastName(evt) {
    this.setState({ soLastName: evt.target.value });
  }

  validateSoLastName() {
    setTimeout(() => {
      this.setState({ soLastNameError: nameValidation(this.state.soLastName) });
    }, 100);
  }

  saveSoName() {
    
    let firstNameError = nameValidation(this.state.soFirstName);
    let lastNameError = nameValidation(this.state.soLastName);
    
    if(firstNameError || lastNameError) {
      this.setState({ 
        soFirstNameError: firstNameError, 
        soLastNameError: lastNameError,
      });
    } else {
      this.setState({ soNameOpen: false }, () => {
        this.syncUserProfile({
          soFirstName: this.state.soFirstName,
          soLastName: this.state.soLastName,
        });
      });
    }
  }


  // ===== //
  // Phone //
  // ===== //

  openPhone() {
    this.setState({ phoneOpen: true });
  }

  changePhone(evt) {
    this.setState({ phone: stringToDigits(evt.target.value) });
  }

  validatePhone() {
    setTimeout(() => {
      this.setState({ phoneError: phoneValidation(this.state.phone) });
    }, 100);
  }

  savePhone() {
    let phoneError = phoneValidation(this.state.phone);
    if(phoneError) {
      this.setState({ phoneError: phoneError });
    } else {
      this.setState({ phoneOpen: false }, () => {
        this.syncUserProfile({
          phone: this.state.phone,
        });
      });
    }
  }

  // ===== //
  // Email //
  // ===== //

  openEmail() {
    this.setState({ emailOpen: true });
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  validateEmail() {
    setTimeout(() => {
      this.setState({ emailError: emailValidation(this.state.email) });
    }, 100);
  }

  saveEmail() {
    let emailError = emailValidation(this.state.email);
    if(emailError) {
      this.setState({ emailError: emailError });
    } else {
      this.setState({ emailOpen: false }, () => {
        this.syncUserProfile({
          email: this.state.email,
        });
      });
    }
  }

  // ======== //
  // SO Email //
  // ======== //

  openSoEmail() {
    this.setState({ soEmailOpen: true });
  }

  changeSoEmail(evt) {
    this.setState({ soEmail: evt.target.value });
  }

  validateSoEmail() {
    setTimeout(() => {
      this.setState({ soEmailError: emailValidation(this.state.soEmail) });
    }, 100);
  }

  saveSoEmail() {
    let emailError = emailValidation(this.state.soEmail);
    if(emailError) {
      this.setState({ soEmailError: emailError });
    } else {
      this.setState({ soEmailOpen: false }, () => {
        this.syncUserProfile({
          soEmail: this.state.soEmail,
        });
      });
    }
  }

  // ======== //
  // Birthday //
  // ======== //

  openBirthday() {
    this.setState({ birthdayOpen: true });
  }

  changeBirthday(evt) {
    this.setState({ birthday: stringToDigits(evt.target.value) });
  }

  validateBirthday() {

    if(this.state.birthday.trim() == '') {
      return;
    }

    setTimeout(() => {
      this.setState({ birthdayError: dateValidation(this.state.birthday) });
    }, 100);
  }

  saveBirthday() {
    
    let birthdayError = null;
    if(this.state.birthday.trim().length > 0) {
      birthdayError = dateValidation(this.state.birthday);
    }

    if(birthdayError) {
      this.setState({ birthdayError: birthdayError });
    } else {
      this.setState({ birthdayOpen: false }, () => {
        this.syncUserProfile({
          birthday: formatDateForDb(this.state.birthday),
        });
      });
    }
  }

  // =========== //
  // SO Birthday //
  // =========== //

  openSoBirthday() {
    this.setState({ soBirthdayOpen: true });
  }

  changeSoBirthday(evt) {
    this.setState({ soBirthday: stringToDigits(evt.target.value) });
  }

  validateSoBirthday() {

    if(this.state.soBirthday.trim() == '') {
      return;
    }

    setTimeout(() => {
      this.setState({ soBirthdayError: dateValidation(this.state.soBirthday) });
    }, 100);
  }

  saveSoBirthday() {
    
    let birthdayError = null;
    if(this.state.soBirthday.trim().length > 0) {
      birthdayError = dateValidation(this.state.soBirthday);
    }

    if(birthdayError) {
      this.setState({ soBirthdayError: birthdayError });
    } else {
      this.setState({ soBirthdayOpen: false }, () => {
        this.syncUserProfile({
          soBirthday: formatDateForDb(this.state.soBirthday),
        });
      });
    }
  }

  // =========== //
  // Anniversary //
  // =========== //

  openAnniversary() {
    this.setState({ anniversaryOpen: true });
  }

  changeAnniversary(evt) {
    this.setState({ anniversary: evt.target.value });
  }

  validateAnniversary() {
    setTimeout(() => {
      this.setState({ anniversaryError: dateValidation(this.state.anniversary) });
    }, 100);
  }

  saveAnniversary() {
    let anniversaryError = dateValidation(this.state.anniversary);
    if(anniversaryError) {
      this.setState({ anniversaryError: anniversaryError });
    } else {
      this.setState({ anniversaryOpen: false }, () => {
        this.syncUserProfile({
          anniversary: formatDateForDb(this.state.anniversary),
        });
      });
    }
  }

  // ========= //
  // Ring Size //
  // ========= //

  openRingSize() {
    this.setState({ ringSizeOpen: true });
  }

  changeRingSize(evt, index, type) {
    console.log(evt.target.value);
    console.log(index);
    console.log(type);
    // this.setState({ ringSize: evt.target.value });


    // ringSize: [
    //     {
    //       finger: 'Left ring',
    //       size: '6.00',
    //     },
    //   ],

    let newSizes = [];
    let addingSize = index >= this.state.ringSize.length;

    for(let i = 0; i < this.state.ringSize.length; i++) {
      let size = {
        finger: this.state.ringSize[i].finger,
        size: this.state.ringSize[i].size,
      }
      if(i === index) {
        if(type == 'finger') {
          size.finger = evt.target.value;
        } else if(type == 'size') {
          size.size = evt.target.value;
        }
      }
      newSizes.push(size);
    }
    if(addingSize) {
      let size = {
        finger: type == 'finger' ? evt.target.value : '',
        size: type == 'size' ? evt.target.value : '',
      }
      newSizes.push(size);
    }
    this.setState({ ringSize: newSizes }, () => {
      console.log(this.state.ringSize);
    });
  }

  saveRingSize() {
    this.setState({ ringSizeOpen: false }, () => {
      this.syncUserProfile({
        ringSizes: this.state.ringSize,
      });
    });
  }

  renderRingSize(index) {

    let ringCount = this.state.ringSize.length;
    let hasData = index <= (ringCount - 1);

    return <div className={'singleItemElement accountElement'} key={index}>
      {index === 0 ?
        <div className='elementLabel'>Ring Sizes</div> :
        <div className='elementLabel'>&nbsp;</div>
      }
      {!this.state.ringSizeOpen ?
        <div>
          {hasData ?
            <div className='elementValue'>{this.state.ringSize[index].finger + ': ' + this.state.ringSize[index].size}</div> :
            null
          }
          <div className='elementEdit' onClick={::this.openRingSize}>{hasData ? 'Edit' : 'Add Ring'}</div>
        </div> :
        <div>
          <div className='editWrapper'>
            <div className='editInput'>
              <select
                value={hasData ? this.state.ringSize[index].finger : ''}
                onChange={(evt) => this.changeRingSize(evt, index, 'finger')}
                className='fingerSelect'>
                {this.state.ringFingerData.map((finger, i) => {
                  return <option key={i} value={finger.value}>{finger.display}</option>;
                })}
              </select>
              <select
                value={hasData ? this.state.ringSize[index].size : ''}
                onChange={(evt) => this.changeRingSize(evt, index, 'size')}
                className='sizeSelect'>
                {this.state.ringSizeData.map((size, j) => {
                  return <option key={j} value={size.value}>{size.display}</option>;
                })}
              </select>
            </div>
          </div>
          {index === 0 ?
            <div className='elementEdit' onClick={::this.saveRingSize}>Save</div> :
            null
          }
        </div>
      }
    </div>
  }

  // ============ //
  // Home Address //
  // ============ //

  openHomeAddress() {
    this.setState({ homeAddressOpen: true });
  }

  changeHomeAddressStreet1(evt) {
    this.setState({ homeAddressStreet1: evt.target.value });
  }

  changeHomeAddressStreet2(evt) {
    this.setState({ homeAddressStreet2: evt.target.value });
  }

  changeHomeAddressCity(evt) {
    this.setState({ homeAddressCity: evt.target.value });
  }

  changeHomeAddressState(evt) {
    this.setState({ homeAddressState: evt.target.value });
  }

  changeHomeAddressZip(evt) {
    this.setState({ homeAddressZip: evt.target.value });
  }

  validateHomeAddress() {

    // Required
    let street1Error = locationValidation(this.state.homeAddressStreet1);
    let street2Error = null;
    let cityError = locationValidation(this.state.homeAddressCity);
    let stateError = this.state.homeAddressState === '' ? 'Enter a state' : null;
    let zipError = zipValidation(this.state.homeAddressZip);

    // Optional
    if(this.state.homeAddressStreet2.trim() !== '') {
      street2Error = locationValidation(this.state.homeAddressStreet2);
    }

    this.setState({
      homeAddressStreet1Error: street1Error,
      homeAddressStreet2Error: street2Error,
      homeAddressCityError: cityError,
      homeAddressStateError: stateError,
      homeAddressZipError: zipError,
    });

    if(
      street1Error === null && 
      street2Error === null && 
      cityError === null && 
      stateError === null && 
      zipError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  saveHomeAddress() {
    if(this.validateHomeAddress()) {
      this.setState({ homeAddressOpen: false }, () => {
        this.syncUserProfile({
          homeAddressId: this.state.homeAddressId,
          homeAddressStreet1: this.state.homeAddressStreet1,
          homeAddressStreet2: this.state.homeAddressStreet2,
          homeAddressCity: this.state.homeAddressCity,
          homeAddressState: this.state.homeAddressState,
          homeAddressZip: this.state.homeAddressZip,
        });
      });
    }
  }

  // ================ //
  // Shipping Address //
  // ================ //

  openShippingAddress() {
    this.setState({ shippingAddressOpen: true });
  }

  changeShippingAddressStreet1(evt) {
    this.setState({ shippingAddressStreet1: evt.target.value });
  }

  changeShippingAddressStreet2(evt) {
    this.setState({ shippingAddressStreet2: evt.target.value });
  }

  changeShippingAddressCity(evt) {
    this.setState({ shippingAddressCity: evt.target.value });
  }

  changeShippingAddressState(evt) {
    this.setState({ shippingAddressState: evt.target.value });
  }

  changeShippingAddressZip(evt) {
    this.setState({ shippingAddressZip: evt.target.value });
  }

  validateShippingAddress() {

    // Required
    let street1Error = locationValidation(this.state.shippingAddressStreet1);
    let street2Error = null;
    let cityError = locationValidation(this.state.shippingAddressCity);
    let stateError = this.state.shippingAddressState === '' ? 'Enter a state' : null;
    let zipError = zipValidation(this.state.shippingAddressZip);

    // Optional
    if(this.state.shippingAddressStreet2.trim() !== '') {
      street2Error = locationValidation(this.state.shippingAddressStreet2);
    }

    this.setState({
      shippingAddressStreet1Error: street1Error,
      shippingAddressStreet2Error: street2Error,
      shippingAddressCityError: cityError,
      shippingAddressStateError: stateError,
      shippingAddressZipError: zipError,
    });

    if(
      street1Error === null && 
      street2Error === null && 
      cityError === null && 
      stateError === null && 
      zipError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  saveShippingAddress() {
    if(this.validateShippingAddress()) {
      this.setState({ shippingAddressOpen: false }, () => {
        this.syncUserProfile({
          shippingAddressId: this.state.shippingAddressId,
          shippingAddressStreet1: this.state.shippingAddressStreet1,
          shippingAddressStreet2: this.state.shippingAddressStreet2,
          shippingAddressCity: this.state.shippingAddressCity,
          shippingAddressState: this.state.shippingAddressState,
          shippingAddressZip: this.state.shippingAddressZip,
        });
      });
    }
  }

  // =========== //
  // Local Store //
  // =========== //

  openLocalStore() {
    this.setState({ localStoreOpen: true });
  }

  changeLocalStore(evt) {
    this.setState({ localStore: evt.target.value });
  }

  saveLocalStore() {
    this.setState({ localStoreOpen: false }, () => {
      this.syncUserProfile({
        localStore: this.state.localStore,
      });
    });
  }

  getStoreAddress(key, line) {

    if(!key) {
      return '';
    }
    for(let i = 0; i < locations.length; i++) {
      if(key == locations[i]['number']) {
        return locations[i]['address' + line];
      }
    }
  }

  getStoreTitle(key) {

    if(!key) {
      return '';
    }
    for(let i = 0; i < locations.length; i++) {
      if(key == locations[i]['number']) {
        return locations[i]['title'];
      }
    }
  }

  getStoreEmail(key) {

    if(!key) {
      return '';
    }
    for(let i = 0; i < locations.length; i++) {
      if(key == locations[i]['number']) {
        return locations[i]['email'];
      }
    }
  }

  getStorePhone(key) {

    if(!key) {
      return '';
    }
    for(let i = 0; i < locations.length; i++) {
      if(key == locations[i]['number']) {
        return locations[i]['phone'];
      }
    }
  }

  // ======== //
  // Password //
  // ======== //

  openPassword() {
    this.setState({ passwordOpen: true });
  }

  changeOldPassword(evt) {
    this.setState({ oldPassword: evt.target.value });
  }

  changePassword1(evt) {
    this.setState({ newPassword1: evt.target.value });
  }

  changePassword2(evt) {
    this.setState({ newPassword2: evt.target.value });
  }

  savePassword() {
    let passwordError = passwordValidation(this.state.newPassword1);
    if(passwordError === null && this.state.newPassword1 != this.state.newPassword2) {
      passwordError = 'Passwords must match';
    } else if(this.state.oldPassword.length === 0) {
      passwordError = 'Enter current password';
    }
    if(passwordError) {
      this.setState({ passwordError: passwordError });
    } else {
      this.setState({ 
        passwordOpen: false,
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
        passwordReset: true,
      });
    }
  }

  // ========== //
  // Email Opt  //
  // ========== //

  toggleEmailPreference() {
    this.setState({ optIn: !this.state.optIn }, () => {
      this.props.commonAlert('Email preferences updated');
    });
  }

	render() {
		return <div className='AccountInfo'>
      <div className='sectionTitle'>Account Info</div>
      {this.props.user.userCore === null ?
        <div className='infoSectionWrapper'>
          <RhinoLoading />
        </div> :
        <div className='infoSectionWrapper'>
          <div className='accountInfoCopy' style={{marginBottom: '20px'}}>Editing your email address below will not impact open orders, only your account login. Please email <a href='mailto:online@diamondsdirect.com'>online@diamondsdirect.com</a> to update contact information related to open orders.</div>
          <div className={'singleItemElement accountElement'}>
            <div className='elementLabel'>Name</div>
            {!this.state.nameOpen ?
              <div>
                <div className='elementValue'>{this.state.firstName + ' ' + this.state.lastName}</div>
                <div className='elementEdit' onClick={::this.openName}>Edit</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={this.state.firstName}
                      onChange={::this.changeFirstName}
                      onBlur={::this.validateFirstName}
                      className={this.state.firstNameError ? 'error' : 'accountInput'}
                      placeholder='First Name' />
                  </div>
                  {this.state.firstNameError ?
                    <div className='editError'>{this.state.firstNameError}</div> :
                    null
                  }
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={this.state.lastName}
                      onChange={::this.changeLastName}
                      onBlur={::this.validateLastName}
                      className={this.state.lastNameError ? 'error' : 'accountInput'}
                      placeholder='Last Name' />
                  </div>
                  {this.state.lastNameError ?
                    <div className='editError'>{this.state.lastNameError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveName}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'}>
            <div className='elementLabel'>Phone Number</div>
            {!this.state.phoneOpen ?
              <div>
                <div className='elementValue'>{displayPhone(this.state.phone)}</div>
                <div className='elementEdit' onClick={::this.openPhone}>Edit</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='phone'
                      value={displayPhoneInput(this.state.phone)}
                      onChange={::this.changePhone}
                      onBlur={::this.validatePhone}
                      className={this.state.phoneError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.phoneError ?
                    <div className='editError'>{this.state.phoneError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.savePhone}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'}>
            <div className='elementLabel'>Email Address</div>
            {!this.state.emailOpen ?
              <div>
                <div className='elementValue EllipsisElement'>{this.state.email}</div>
                <div className='elementEdit' onClick={::this.openEmail}>Edit</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='email'
                      value={this.state.email}
                      onChange={::this.changeEmail}
                      onBlur={::this.validateEmail}
                      className={this.state.emailError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.emailError ?
                    <div className='editError'>{this.state.emailError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveEmail}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Birthday</div>
            {!this.state.birthdayOpen ?
              <div>
                <div className='elementValue'>{displayDateInput(this.state.birthday)}</div>
                <div className='elementEdit' onClick={::this.openBirthday}>{this.state.birthday === '' ? 'Add' : 'Save'}</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={displayDateInput(this.state.birthday)}
                      onChange={::this.changeBirthday}
                      onBlur={::this.validateBirthday}
                      placeholder='MM-DD-YYYY'
                      className={this.state.birthdayError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.birthdayError ?
                    <div className='editError'>{this.state.birthdayError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveBirthday}>Save</div>
              </div>
            }
          </div>
          <div>&nbsp;</div>
          <div className={'singleItemElement accountElement'}>
            <div className='elementLabel'>Spouse's Name</div>
            {!this.state.soNameOpen ?
              <div>
                <div className='elementValue'>{this.state.soFirstName + ' ' + this.state.soLastName}</div>
                <div className='elementEdit' onClick={::this.openSoName}>Edit</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={this.state.soFirstName}
                      onChange={::this.changeSoFirstName}
                      onBlur={::this.validateSoFirstName}
                      className={this.state.soFirstNameError ? 'error' : 'accountInput'}
                      placeholder='First Name' />
                  </div>
                  {this.state.soFirstNameError ?
                    <div className='editError'>{this.state.soFirstNameError}</div> :
                    null
                  }
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={this.state.soLastName}
                      onChange={::this.changeSoLastName}
                      onBlur={::this.validateSoLastName}
                      className={this.state.soLastNameError ? 'error' : 'accountInput'}
                      placeholder='Last Name' />
                  </div>
                  {this.state.soLastNameError ?
                    <div className='editError'>{this.state.soLastNameError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveSoName}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'}>
            <div className='elementLabel'>Spouse's Email</div>
            {!this.state.soEmailOpen ?
              <div>
                <div className='elementValue'>{this.state.soEmail}</div>
                <div className='elementEdit' onClick={::this.openSoEmail}>Edit</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='email'
                      value={this.state.soEmail}
                      onChange={::this.changeSoEmail}
                      onBlur={::this.validateSoEmail}
                      className={this.state.soEmailError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.soEmailError ?
                    <div className='editError'>{this.state.soEmailError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveSoEmail}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Spouse's Birthday</div>
            {!this.state.soBirthdayOpen ?
              <div>
                <div className='elementValue'>{displayDateInput(this.state.soBirthday)}</div>
                <div className='elementEdit' onClick={::this.openSoBirthday}>{this.state.soBirthday === '' ? 'Add' : 'Save'}</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={displayDateInput(this.state.soBirthday)}
                      onChange={::this.changeSoBirthday}
                      onBlur={::this.validateSoBirthday}
                      placeholder='MM-DD-YYYY'
                      className={this.state.soBirthdayError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.soBirthdayError ?
                    <div className='editError'>{this.state.soBirthdayError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveSoBirthday}>Save</div>
              </div>
            }
          </div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Anniversary</div>
            {!this.state.anniversaryOpen ?
              <div>
                <div className='elementValue'>{displayDate(this.state.anniversary)}</div>
                <div className='elementEdit' onClick={::this.openAnniversary}>{this.state.anniversary === '' ? 'Add' : 'Edit'}</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <input 
                      type='text'
                      value={displayDateInput(this.state.anniversary)}
                      onChange={::this.changeAnniversary}
                      onBlur={::this.validateAnniversary}
                      placeholder='MM-DD-YYYY'
                      className={this.state.anniversaryError ? 'error' : 'accountInput'} />
                  </div>
                  {this.state.anniversaryError ?
                    <div className='editError'>{this.state.anniversaryError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.saveAnniversary}>Save</div>
              </div>
            }
          </div>

          {this.state.ringSize.length == 0 ?
            <div>{this.renderRingSize(0)}</div> :
            <div>
              {this.state.ringSize.map((rsize, i) => {
                if(i > 4) {
                  return null;
                }
                return this.renderRingSize(i);
              })}
              {this.state.ringSize.length <= 4 ?
                <span>{this.renderRingSize(this.state.ringSize.length)}</span> :
                null
              }
            </div>
          }

          <div className='databreak'></div>
          <div className={'addressItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Home Address</div>
            {!this.state.homeAddressOpen ?
              <div>
                {this.state.homeAddressStreet1 ?
                  <div className={'elementAddress1 elementValue'}>{this.state.homeAddressStreet1}</div> :
                  null
                }
                {this.state.homeAddressStreet2 ?
                  <div className={'elementAddress2 elementValue'}>{this.state.homeAddressStreet2}</div> :
                  null
                }
                {this.state.homeAddressCity && this.state.homeAddressState && this.state.homeAddressZip ?
                  <div className={'elementAddress3 elementValue'}>
                    {this.state.homeAddressCity + ', ' + this.state.homeAddressState + ' ' + this.state.homeAddressZip}
                  </div> :
                  null
                }
                <div className='elementEdit' onClick={::this.openHomeAddress}>{this.state.homeAddressStreet1 === '' ? 'Add' : 'Edit'}</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className={'editInput addressInput'}>
                    <input 
                      type='text'
                      value={this.state.homeAddressStreet1}
                      onChange={::this.changeHomeAddressStreet1}
                      placeholder='Street Address'
                      className={this.state.homeAddressStreet1Error ? 'error' : 'accountInput'} />
                  </div>
                  <div className={'editInput addressInput'}>
                    <input 
                      type='text'
                      value={this.state.homeAddressStreet2}
                      onChange={::this.changeHomeAddressStreet2}
                      placeholder='Street Address (Optional)'
                      className={this.state.homeAddressStreet2Error ? 'error' : 'accountInput'} />
                  </div>
                  <div className={'editInput addressInput'}>
                    <div className='cityWrapper'>
                      <input 
                        type='text'
                        value={this.state.homeAddressCity}
                        onChange={::this.changeHomeAddressCity}
                        placeholder='City'
                        className={this.state.homeAddressCityError ? 'error' : 'accountInput'} />
                    </div>
                    <div className='stateWrapper'>
                      <select
                        value={this.state.homeAddressState}
                        onChange={::this.changeHomeAddressState}>
                        {this.state.stateDropdownData.map((state, i) => {
                          return <option key={i} value={state.value}>{state.display}</option>;
                        })}
                      </select>
                    </div>
                    <div className='zipWrapper'>
                      <input 
                        type='text'
                        value={this.state.homeAddressZip}
                        onChange={::this.changeHomeAddressZip}
                        placeholder='Postal Code'
                        className={this.state.homeAddressZipError ? 'error' : 'accountInput'} />
                    </div>
                  </div>
                </div>
                <div className='elementEdit' onClick={::this.saveHomeAddress}>Save</div>
              </div>
            }
          </div>
          <div className={'addressItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Shipping Address</div>
            {!this.state.shippingAddressOpen ?
              <div>
                {this.state.shippingAddressStreet1 ?
                  <div className={'elementAddress1 elementValue'}>{this.state.shippingAddressStreet1}</div> :
                  null
                }
                {this.state.shippingAddressStreet2 ?
                  <div className={'elementAddress2 elementValue'}>{this.state.shippingAddressStreet2}</div> :
                  null
                }
                {this.state.shippingAddressCity && this.state.shippingAddressState && this.state.shippingAddressZip ?
                  <div className={'elementAddress3 elementValue'}>
                    {this.state.shippingAddressCity + ', ' + this.state.shippingAddressState + ' ' + this.state.shippingAddressZip}
                  </div> :
                  null
                }
                <div className='elementEdit' onClick={::this.openShippingAddress}>{this.state.shippingAddressStreet1 === '' ? 'Add' : 'Edit'}</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className={'editInput addressInput'}>
                    <input 
                      type='text'
                      value={this.state.shippingAddressStreet1}
                      onChange={::this.changeShippingAddressStreet1}
                      placeholder='Street Address'
                      className={this.state.shippingAddressStreet1Error ? 'error' : 'accountInput'} />
                  </div>
                  <div className={'editInput addressInput'}>
                    <input 
                      type='text'
                      value={this.state.shippingAddressStreet2}
                      onChange={::this.changeShippingAddressStreet2}
                      placeholder='Street Address (Optional)'
                      className={this.state.shippingAddressStreet2Error ? 'error' : 'accountInput'} />
                  </div>
                  <div className={'editInput addressInput'}>
                    <div className='cityWrapper'>
                      <input 
                        type='text'
                        value={this.state.shippingAddressCity}
                        onChange={::this.changeShippingAddressCity}
                        placeholder='City'
                        className={this.state.shippingAddressCityError ? 'error' : 'accountInput'} />
                    </div>
                    <div className='stateWrapper'>
                      <select
                        value={this.state.shippingAddressState}
                        onChange={::this.changeShippingAddressState}>
                        {this.state.stateDropdownData.map((state, i) => {
                          return <option key={i} value={state.value}>{state.display}</option>;
                        })}
                      </select>
                    </div>
                    <div className='zipWrapper'>
                      <input 
                        type='text'
                        value={this.state.shippingAddressZip}
                        onChange={::this.changeShippingAddressZip}
                        placeholder='Postal Code'
                        className={this.state.shippingAddressZipError ? 'error' : 'accountInput'} />
                    </div>
                  </div>
                </div>
                <div className='elementEdit' onClick={::this.saveShippingAddress}>Save</div>
              </div>
            }
          </div>
          <div className={'addressItemElement accountElement'}>
            <div className='elementLabel'>Your Home Store</div>
            {!this.state.localStoreOpen ?
              <div>
                <div className={'elementAddress1 elementValue'} style={{fontWeight: '700'}}>{this.getStoreTitle(this.state.localStore)}</div>
                <div className={'elementAddress1 elementValue'}>{this.getStoreAddress(this.state.localStore, 1)}</div>
                <div className={'elementAddress2 elementValue'}>{this.getStoreAddress(this.state.localStore, 2)}</div>
                <div className={'elementEmail elementValue'}><a href={'mailto:' + this.getStoreEmail(this.state.localStore)}>{this.getStoreEmail(this.state.localStore)}</a></div>
                <div className={'elementPhone elementValue'}><a href={'tel:' + this.getStorePhone(this.state.localStore)}>{displayPhoneInput(this.getStorePhone(this.state.localStore))}</a></div>
                <div className='elementEdit' onClick={::this.openLocalStore}>Set My Home Store</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className='editInput'>
                    <select
                      value={this.state.localStore}
                      onChange={::this.changeLocalStore}>
                      {this.state.locationDropdownData.map((size, i) => {
                        return <option key={i} value={size.value}>{size.display}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className='elementEdit' onClick={::this.saveLocalStore}>Save</div>
              </div>
            }
          </div>
          <div className={'passwordItemElement accountElement'}>
            <div className='elementLabel'>{this.state.passwordReset ? 'Password Reset' : 'Password'}</div>
            {!this.state.passwordOpen ?
              <div>
                <div className='elementEdit' onClick={::this.openPassword}>Change Password</div>
              </div> :
              <div>
                <div className='editWrapper'>
                  <div className={'editInput oldPasswordInput'}>
                    <input 
                      type='password'
                      placeholder='Current password'
                      value={this.state.oldPassword}
                      onChange={::this.changeOldPassword} />
                  </div>
                  <div className='editInput'>
                    <input 
                      type='password'
                      placeholder='New password'
                      value={this.state.newPassword1}
                      onChange={::this.changePassword1} />
                  </div>
                  <div className='editInput'>
                    <input 
                      type='password'
                      placeholder='Re-enter password'
                      value={this.state.newPassword2}
                      onChange={::this.changePassword2} />
                  </div>
                  {this.state.passwordError ?
                    <div className='editError'>{this.state.passwordError}</div> :
                    null
                  }
                </div>
                <div className='elementEdit' onClick={::this.savePassword}>Save</div>
              </div>
            }
          </div>
          <div className='databreak'></div>
          <div className={'optElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Subscription Settings</div>
            <div className='elementValue'>Stay updated with special events and promotions from Diamonds Direct.</div>
          </div>
          <div className='databreak' style={{display: 'none'}}></div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Personal Email</div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='personal' checked />
              </div>
              <div className='emailLabel'>Sign me up!</div>
            </div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='personal' />
              </div>
              <div className='emailLabel'>Unsubscribe</div>
            </div>
          </div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Spouse's Email</div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='spouse' checked />
              </div>
              <div className='emailLabel'>Sign me up!</div>
            </div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='spouse' />
              </div>
              <div className='emailLabel'>Unsubscribe</div>
            </div>
          </div>
          <div className={'singleItemElement accountElement'} style={{display: 'none'}}>
            <div className='elementLabel'>Direct Mail</div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='direct' checked />
              </div>
              <div className='emailLabel'>Sign me up!</div>
            </div>
            <div className='emailRow'>
              <div className='emailInput'>
                <input type='radio' name='direct' />
              </div>
              <div className='emailLabel'>Unsubscribe</div>
            </div>
          </div>
        </div>
      }
		</div>;
	}
}
export default AccountInfo;

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export const AccountInfoContainer = connect(
  mapStateToProps,
  allActionCreators
)(AccountInfo);


// WEBPACK FOOTER //
// ./src/components/views/account/blocks/AccountInfo.jsx